import { render, staticRenderFns } from "./requirementSummary.vue?vue&type=template&id=485b3d0d&"
import script from "./requirementSummary.vue?vue&type=script&lang=js&"
export * from "./requirementSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports